export default "__VITE_ASSET__BsqRa28I__"